import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: {},
    frequencyGrouped: [],
    summary: {
      totalManufacturingUnits: 0,
      totalQuantity: 0,
      totalValue: 0,
      statusBreakdown: {},
    },
  },
  loading: false,
  error: null,
};

const warehouseStatusCountReportSlice = createSlice({
  name: "WarehouseStatusCountReport",
  initialState,
  reducers: {
    WarehouseStatusCountReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    WarehouseStatusCountReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload; // payload contains { business, frequencyGrouped, summary }
    },
    WarehouseStatusCountReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions and reducer
export const {
  WarehouseStatusCountReportRequest,
  WarehouseStatusCountReportSuccess,
  WarehouseStatusCountReportFailure,
} = warehouseStatusCountReportSlice.actions;

export default warehouseStatusCountReportSlice.reducer;
